export enum InvoiceType {
  BOOKING = 'BOOKING',
  DAMAGE = 'DAMAGE',
  CANCELLATION_FEE = 'CANCELLATION_FEE',
  ADMINISTRATIVE_OFFENCE = 'ADMINISTRATIVE_OFFENCE',
  REVERSAL = 'REVERSAL',
  OTHER = 'OTHER',
  GENERIC = 'GENERIC',
  CAR_SALE = 'CAR_SALE',
  COUPON = 'COUPON',
  SELF_BILLING = 'SELF_BILLING',
  CONTRACT_PENALTY = 'CONTRACT_PENALTY',
}
